module.exports = __webpack_public_path__ + "img/960.86555dc4.svg";